"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var Defaults = {
    baseUrl: "/api",
    auth: undefined
};
var RestUserService = /** @class */ (function () {
    function RestUserService() {
    }
    Object.defineProperty(RestUserService.prototype, "baseUrl", {
        get: function () {
            return this._baseUrl || Defaults.baseUrl;
        },
        set: function (value) {
            this._baseUrl = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RestUserService.prototype, "auth", {
        get: function () {
            return this._auth || Defaults.auth;
        },
        set: function (value) {
            this._auth = value;
        },
        enumerable: true,
        configurable: true
    });
    RestUserService.prototype.getUsers = function (request) {
        return axios_1.default.get(this.baseUrl + "/user/", { params: request, auth: this.auth }).then(function (value) {
            return value.data;
        });
    };
    RestUserService.prototype.getUserProfile = function () {
        return axios_1.default.get(this.baseUrl + "/self/profile/", { auth: this.auth }).then(function (value) {
            return value.data;
        });
    };
    return RestUserService;
}());
exports.RestUserService = RestUserService;
